import { createSlideIcon, type IconProps } from '../SlideTypeIcon';

const DEFAULT_COLOR = 'var(--palette-blue-500)';

const Icon24x24 = ({ textColor = DEFAULT_COLOR }: IconProps) => (
  <>
    <path d="M14 5H4V8H6V7H8V17H6V19H12V17H10V7H12V8H14V5Z" fill={textColor} />
    <path d="M17 18V6H16V4H20V6H19V18H20V20H16V18H17Z" fill={textColor} />
  </>
);

const Icon32x32 = ({ textColor = DEFAULT_COLOR }: IconProps) => (
  <>
    <path
      d="M18 9H8V12H10V11H12V21H10V23H16V21H14V11H16V12H18V9Z"
      fill={textColor}
    />
    <path d="M21 22V10H20V8H24V10H23V22H24V24H20V22H21Z" fill={textColor} />
  </>
);

export const FreeTextIcon = createSlideIcon(Icon24x24, Icon32x32);
